import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styled from 'styled-components';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export default function ModalWrapper({
  isOpen,
  onClose,
  style = {},
  children,
  ...rest
}: ModalWrapperProps): JSX.Element {
  Modal.setAppElement('#root');
  return (
    <OverlayStyle isOpen={isOpen} style={style} onRequestClose={onClose} {...rest}>
      <ModalStyle>{children}</ModalStyle>
    </OverlayStyle>
  );
}

const OverlayStyle = styled(Modal)`
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  overflow-y: auto;
`;

const ModalStyle = styled.div`
  position: absolute;
  padding: 15px;
  z-index: 9999;
  width: 100%;
`;
